import {
  MapMarker,
  MapMarkerDisplayTypeEnum,
} from "@/custom-types/StoreLocator";

/* eslint-disable no-mixed-operators, prettier/prettier -- Prettier does not like the no-mixed-operators eslint rule, but we do :) */
export const calculateRadiusInMiles = ({
  lon,
  lat,
  center_lat,
  center_lon,
}: {
  lon: number;
  lat: number;
  center_lat: number;
  center_lon: number;
}) => {
  const r = 3963.0;

  // Convert lat or lng from decimal degrees into radians (divide by 57.2958)
  const lat1 = center_lat / 57.2958;
  const lon1 = center_lon / 57.2958;
  const lat2 = lat / 57.2958;
  const lon2 = lon / 57.2958;

  // distance = circle radius from center to Northeast corner of bounds
  return (
    r *
    Math.acos(
      Math.sin(lat1) * Math.sin(lat2) +
        Math.cos(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1),
    )
  );
};

export const radiusToZoom = (radius: number) => {
  return Math.round(14 - Math.log(Number(radius)) / Math.LN2);
};

export const isMapMarkerPlatinum = (mapMarker: MapMarker) =>
  mapMarker.displayType === MapMarkerDisplayTypeEnum.ProminentImageContainer;
